import React, { useState } from "react";
import { Container, Row, Col, Nav, Tab } from "react-bootstrap";
import SliderUpload from "./SliderUpload";
import Sidebar from "../Sidebar";
import TooltipMessage from "../Tooltip";
import { Breadcrumbs } from "./../Breadcrumb/index";
import { ToastContainer } from "react-toastify";

export default function LandingUpload() {

  return (
    <>
      <Container fluid>
        <Row>
          <Sidebar />
          <Col lg={10} style={{ backgroundColor: "#f1f2f3" }}>
            <Row className="p-2">
              <Col className="slidesContent rounded shadow p-3 bg-light">
                <Breadcrumbs currentPathName="Slides Upload" />
                <Tab.Container defaultActiveKey={0}>
                  <div className="tabList">
                    <Nav variant="tabs">
                      <Nav.Item>
                        <Nav.Link eventKey={0}>
                          FIRST SLIDE
                          <small>
                            <TooltipMessage msg="*Resolution (1275px * 280px)" />
                          </small>
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey={1}>
                          SECOND SLIDE
                          <small>
                            <TooltipMessage msg="*Resolution (1275px * 280px)" />
                          </small>
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey={2}>
                          THIRD SLIDE
                          <small>
                            <TooltipMessage msg="*Resolution (1275px * 280px)" />
                          </small>
                        </Nav.Link>
                      </Nav.Item>
                    </Nav>
                  </div>
                  <Tab.Content className="mt-3">
                    <Tab.Pane eventKey={0}>
                      <SliderUpload buttonText="upload slide One" imgId={1} />
                    </Tab.Pane>
                    <Tab.Pane eventKey={1}>
                      <SliderUpload buttonText="upload slide Two" imgId={2} />
                    </Tab.Pane>
                    <Tab.Pane eventKey={2}>
                      <SliderUpload buttonText="upload slide Three" imgId={3} />
                    </Tab.Pane>
                  </Tab.Content>
                </Tab.Container>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
      <ToastContainer />
    </>
  );
}
